module.exports = __webpack_public_path__ + "img/icon-side-bar-5.53fb7033.svg";